<template>
  <v-card style="display: inline-block;vertical-align: middle;" class="mr-auto ml-auto formRecallPassword">
    <v-card-title class="pa-5 pb-3">
      <p>{{ languageData.cardHeader }}</p>
    </v-card-title>
    <v-card-text>
      <v-form
          ref="formR"
          v-if="languageData.labels"
          v-model="validR">
        <v-row class="flex-column">
          <v-col>
            <v-text-field
              :label="languageData.labels.email"
              :rules="this.rules.email"
              single-line
              v-model="data.email"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
                :label="languageData.labels.new_password"
                hide-details="auto"
                type="password"
                single-line
                :rules="this.rules.password"
                v-model="data.password"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
                :label="languageData.labels.confirm_password"
                hide-details="auto"
                type="password"
                single-line
                :rules="this.rules.password_confirmation"
                v-model="data.password_confirmation"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn
                :loading="resetIsFetching"
                class="btnSubmitRecallPasswordForm"
                @click="resetPasswordUser"
                color="primary">{{ languageData.resetPasswordSubmitBtn }}</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <ModalInfo :headModal="modalData.headInfoResetPassword" :typeInfo="modalData.typeInfoResetPassword" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModal" :show-modal="isUserResetPassword" :text-modal="modalData.textInfoResetPassword"></ModalInfo>
  </v-card>
</template>

<script type="text/javascript">
  import { mapActions, mapState } from "vuex";
  import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
  import eventBus from "../../../../event-bus/eventBus";
  import handleFormError from "../../../../helpers/handleFormError";

  export default {
    created() {
      eventBus.$on("resetPasswordFailure", (errorsData) => {
        this.rules = handleFormError(errorsData);
        this.$refs.formR.validate();
      });
    },
    name: "ResetPasswordForm",
    components: {ModalInfo},
    data() {
      return {
        data: {},
        rules: {},
        validR: false
      }
    },
    computed: {
      ...mapState("resetPassword", {
        resetIsFetching: state => state.resetIsFetching,
        isUserResetPassword: state => state.isUserResetPassword,
        modalData: state => state.modalData
      }),
    },
    methods: {
      ...mapActions("resetPassword", ["resetPassword", "updateVisibleModal"]),
      resetPasswordUser: function() {
        this.rules = [];
        this.$refs.formR.resetValidation();
        this.data.language = this.language;
        this.data.token = this.$route.query.token;
        this.resetPassword({ creds: this.data });
      },

      hideModal: function() {
        this.updateVisibleModal(false);
      }
    }
  }
</script>

<style src="./ResetPasswordForm.scss" lang="scss"></style>